module.exports = __webpack_public_path__ + "static/img/normal.0447fe9b.png";